import { loginInfo } from '@stores/atoms/login';
import { atom } from 'jotai';

export const isLogin = atom((get) => {
  return !!get(loginInfo).displayNo;
});

export const attendeeInfo = atom((get) => {
  return get(loginInfo);
});
